import React from 'react';

import PropTypes from 'prop-types';
import ActionEditor from './ActionEditor';
import ActionCreator from './ActionCreator';
import ActionType from 'src/enums/actionType';

const lang = {
  title: {
    [ActionType.SMS.id]: 'smartmessaging.campaignAction.cardTitle.SMS',
    [ActionType.EMAIL.id]: 'smartmessaging.campaignAction.cardTitle.EMAIL',
    [ActionType.EMAIL_COACH.id]: 'smartmessaging.campaignAction.cardTitle.EMAIL',
    [ActionType.MEMBER_NOTIFICATION.id]:
      'smartmessaging.campaignAction.cardTitle.MEMBER_NOTIFICATION',
    [ActionType.PUSH_XPLORACTIVE.id]: 'smartmessaging.campaignAction.cardTitle.PUSH_XPLORACTIVE',
    [ActionType.PROSPECTING.id]: 'smartmessaging.campaignAction.cardTitle.PROSPECTING',
    [ActionType.XPLORACTIVE_NEWS.id]: 'smartmessaging.campaignAction.cardTitle.XPLORACTIVE_NEWS',
  },
  createText: {
    [ActionType.SMS.id]: 'smartmessaging.campaignAction.createTitle.SMS',
    [ActionType.EMAIL.id]: 'smartmessaging.campaignAction.createTitle.EMAIL',
    [ActionType.EMAIL_COACH.id]: 'smartmessaging.campaignAction.createTitle.EMAIL',
    [ActionType.MEMBER_NOTIFICATION.id]:
      'smartmessaging.campaignAction.createTitle.MEMBER_NOTIFICATION',
    [ActionType.PUSH_XPLORACTIVE.id]: 'smartmessaging.campaignAction.createTitle.PUSH_XPLORACTIVE',
    [ActionType.PROSPECTING.id]: 'smartmessaging.campaignAction.createTitle.PROSPECTING',
    [ActionType.XPLORACTIVE_NEWS.id]: 'smartmessaging.campaignAction.createTitle.XPLORACTIVE_NEWS',
  },
};

const ActionItem = ({ actionTypeId, rmId, goToStep, isWritable, action, deleteAction }) => (
  <div style={{ margin: '10px', width: '180px' }}>
    {(action && (
      <ActionEditor
        deleteAction={deleteAction}
        goToStep={goToStep}
        action={action}
        actionTypeId={actionTypeId}
        isWritable={isWritable}
        lang={lang}
      />
    )) ||
      (isWritable && (
        <ActionCreator
          isWritable={isWritable}
          actionTypeId={actionTypeId}
          rmId={rmId}
          goToStep={goToStep}
          lang={lang}
        />
      ))}
  </div>
);

ActionItem.propTypes = {
  actionTypeId: PropTypes.number.isRequired,
  isWritable: PropTypes.bool.isRequired,
  rmId: PropTypes.number,
  goToStep: PropTypes.func.isRequired,
  action: PropTypes.object,
  deleteAction: PropTypes.func,
};

ActionItem.defaultProps = {
  rmId: null,
  action: null,
  deleteAction: null,
};

export default ActionItem;
